import './HeroCarousel.scss'
import HeroCarouselSlides from './HeroCarouselSlides'
import type { HeroCarouselProps } from './hero-carousel'

const HeroCarousel = (data: HeroCarouselProps) => {
  if (!data?.carouselItems?.length) {
    return <></>
  }

  return <HeroCarouselSlides data={data} />
}

export default HeroCarousel
